import React from 'react';
import { connect } from 'react-redux';
import { Dialog, FontIcon } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import CreateTemplateDraft from './components/create-draft-form';
import R from 'ramda';

const CreateDraftDialog = ({ dialogOpen, creatingDraft, updateProps, createDraft, createDraftError, locations }) => {
  const actionButtons = [
    <div key="createDraftError" style={{ color: 'red' }}>
      {createDraftError}
    </div>,
    <FlatButton
      key="cancel"
      label="cancel"
      primary
      onTouchTap={() => updateProps({ dialogOpen: false })}
    />,
    <FlatButton
      key="create"
      label="create"
      loader={creatingDraft}
      secondary
      disabled={!R.any(R.propEq('checked', true), locations)}
      onTouchTap={createDraft}
    />,
  ];
  return (
    <Dialog
      titleStyle={{ padding: '12px 24px' }}
      title={<div style={{ backgroundColor: '#00bcd4', color: 'white', fontSize: '20px', display: 'flex', justifyContent: 'space-between' }}>
        Create Template Draft
        <FontIcon
          className="tc-icon-close"
          style={{ cursor: 'pointer', color: 'white', fontSize: '24px', top: '4px' }}
          onTouchTap={() => updateProps({ dialogOpen: false })}
        />
      </div>}
      open={dialogOpen}
      autoScrollBodyContent
      onRequestClose={() => updateProps({ dialogOpen: false })}
      actions={actionButtons}
    >
      <CreateTemplateDraft updateProps={updateProps}/>
    </Dialog>
  );
};

const mapStateToProps = ({ contracting }) => ({
  dialogOpen: contracting.templateList.get('dialogOpen'),
  createDraftError: contracting.templateList.get('createDraftError'),
  creatingDraft: contracting.templateList.get('creatingDraft'),
  locations: contracting.templateList.get('locations').toJS(),
});

export default connect(mapStateToProps)(CreateDraftDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-template-draft/in-dialog.jsx